export const TABLE_TYPE_CATEGORY = 'CATEGORY'
export const TABLE_TYPE_SECTION = 'SECTION'